import { getHeroData, getHeroImage } from 'draft/heroes/useHeroes';
import { DefaultDraftOptions, GameType, Hero } from 'draft/types';
import React, { useEffect, useState } from 'react';

import { DraftHeroes } from 'draft/utils/drafter';

import { Grid, Image, Transition } from 'semantic-ui-react'

type Props = {
    color: string
    gameType?: GameType
}

const DraftExample = ({ color, gameType }: Props) => {
    const [currentDraft, setCurrentDraft] = useState<any>([])
    const [visible, setVisible] = useState(false);

    let type = DefaultDraftOptions().gameType;
    if (gameType) {
        type = gameType;
    }

    const getDraft = () => {
        return DraftHeroes(getHeroData(type), 3, false)[0];
    }

    const draftEffect = () => {
        setVisible(false);
        setTimeout(() => {
            setVisible(true)
            setCurrentDraft(getDraft())
        }, 500)
    }

    const randomInterval = () : number => {
        const min = 3000
        const max = 6000
        return Math.random() * (max - min) + min;
    }

    useEffect(() => {
        setVisible(true)
        setCurrentDraft(getDraft())

        const interval = setInterval(() => draftEffect(), randomInterval());

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function renderHeroes(): any {
        const heroList: Hero[] = currentDraft;
        return (
            heroList.map((hero, index) => (
                <Grid.Column key={"hero-draft-" + index} style={{ margin: 2 }} >
                    <Transition visible={visible} animation='scale' duration={500}>
                        <Image
                            src={getHeroImage(type, hero)}
                            alt={hero.Name}
                            centered
                            style={{ width: 40 }}
                        />
                    </Transition>
                </Grid.Column>
            ))
        )
    }

    return (
        <div className={"melee-draft-card " + color} style={{margin: '0 3em 0 3em', maxWidth:'490px'}}>
            <Grid columns='equal' relaxed className="hero-images">
                {renderHeroes()}
            </Grid>
        </div>
    )
}

export default DraftExample;